// Snapshot of all currently-mounted form-field wrapper names (raw data-form-field
// values). Built once per submit so mount checks are Set lookups, not N DOM queries.
export const getMountedFormFieldNames = (): Set<string> =>
  new Set(
    Array.from(document.querySelectorAll('[data-form-field]'))
      .map((el) => el.getAttribute('data-form-field'))
      .filter((name): name is string => name !== null)
  );
